export const SAFE_SVG_CONTENT = {
    play: `        <svg
            fill="currentColor"
            width="100%"
            height="100%"
            viewBox="0 0 2889 2889"
            xmlns="http://www.w3.org/2000/svg"
            xml:space="preserve"
            style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"
        >
            <path d="M2039.39,1398.46l-1047.07,-604.535c-43.446,-25.087 -79.015,-4.558 -79.015,45.616l-0,1209.03c-0,50.195 35.569,70.725 79.015,45.616l1047.07,-604.514c43.446,-25.108 43.446,-66.146 0,-91.254l0,0.043Z" />
            <g>
                <clipPath id="_clip1">
                    <rect x="-0.043" y="0" width="2887.5" height="2887.5" />
                </clipPath>
                <g clip-path="url(#_clip1)">
                    <path
                        d="M2774.63,881.944c-72.721,-171.961 -176.845,-326.41 -309.44,-459.006c-132.596,-132.595 -287.044,-236.718 -459.006,-309.44c-178.06,-75.325 -367.209,-113.498 -562.109,-113.498c-194.922,-0 -384.05,38.173 -562.132,113.498c-171.961,72.743 -326.41,176.845 -459.006,309.44c-132.595,132.618 -236.718,287.045 -309.44,459.006c-75.325,178.082 -113.498,367.21 -113.498,562.132c0,194.9 38.173,384.049 113.498,562.109c72.743,171.983 176.845,326.41 309.44,459.006c132.618,132.617 287.045,236.719 459.006,309.44c178.082,75.326 367.21,113.52 562.132,113.52c194.9,0 384.049,-38.194 562.109,-113.52c171.983,-72.721 326.41,-176.845 459.006,-309.44c132.617,-132.596 236.719,-287.044 309.44,-459.006c75.326,-178.06 113.52,-367.209 113.52,-562.109c0,-194.922 -38.194,-384.05 -113.52,-562.132Zm-1330.58,1889.26c-731.771,0 -1327.15,-595.334 -1327.15,-1327.13c0,-731.793 595.356,-1327.15 1327.15,-1327.15c731.792,0 1327.13,595.356 1327.13,1327.15c-0,731.792 -595.335,1327.13 -1327.13,1327.13Z"
                        fill="currentColor"
                    />
                </g>
            </g>
        </svg>`,
    pause: `<svg
            fill="currentColor"
            width="100%"
            height="100%"
            viewBox="0 0 2901 2901"
            xmlns="http://www.w3.org/2000/svg"
            xml:space="preserve"
            style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"
        >
            <g>
                <clipPath id="_clip1">
                    <rect x="-0" y="-0" width="2900" height="2900" />
                </clipPath>
                <g clip-path="url(#_clip1)">
                    <path d="M1450.04,-0c-801.237,-0 -1450.04,653.168 -1450.04,1450.02c-0,801.237 653.168,1450.04 1450.04,1450.04c801.216,0 1450.02,-653.168 1450.02,-1450.04c0,-801.216 -648.806,-1450.02 -1450.02,-1450.02Zm0,2769.42c-727.191,-0 -1319.4,-592.188 -1319.4,-1319.4c0,-727.192 592.21,-1319.38 1319.4,-1319.38c727.192,0 1319.4,592.188 1319.4,1319.38c0,727.192 -592.209,1319.4 -1319.4,1319.4Z" />
                </g>
            </g>
            <path d="M1271.51,744.618l-195.963,0c-47.895,0 -87.088,39.171 -87.088,87.088l-0,1232.31c-0,47.895 39.193,87.088 87.088,87.088l195.963,-0c47.895,-0 87.088,-39.193 87.088,-87.088l-0,-1232.31c-0,-47.917 -39.193,-87.088 -87.088,-87.088Z" />
            <path d="M1824.52,744.618l-195.964,0c-47.895,0 -87.088,39.171 -87.088,87.088l0,1232.31c0,47.895 39.193,87.088 87.088,87.088l195.964,-0c47.895,-0 87.087,-39.193 87.087,-87.088l0,-1232.31c0,-47.917 -39.192,-87.088 -87.087,-87.088Z" />
        </svg>`,
};

export const ALLOWED_OPTIONS = ["playPause"];
